export default __webpack_public_path__ + "static/HighPerformer-8bfa9b377ce96da0201c97184bcc0f68.svg";